import React, {Component} from 'react';
import {connect} from 'react-redux';
import _get from "lodash/get";
import _isEmpty from 'lodash/isEmpty';
import {authUserType} from "../../helpers/propCheck";
import PropTypes from "prop-types";
import ContactPrefs from './ContactPrefs';
import TransactionPrefs from './TransactionPrefs';
import AdditionalPrefs from './AdditionalPrefs';
import {Loader} from '../../components/widgets/Loader';
import {ACCOUNT_CONTACT_PREF_GET_FAILURE} from '../../actions/account';
import {getLangCode, stringBundle} from "../../stringBundle";

export class AlertPreferences extends Component {

  constructor(props) {
    super(props);
    this.localizedStringBundle = stringBundle(getLangCode());
  }

  render() {
    const data = _get(this.props.auth, 'user', '');
    let txmFeatureStatus = _get(data, 'primaryMember.plan.productFeatures.transactionMonitoring.featureStatus', '');
    let txmFulfillStatus = _get(data, 'primaryMember.plan.productFeatures.transactionMonitoring.fulfillmentStatus', '');
    let showTransactionPref = (txmFeatureStatus === 'AVAILABLE' && txmFulfillStatus === 'ENROLLED');
    let isMobileLogin = _get(data, "auth.isMobileLogin", false);
    let isFromPaypal = _get(data, "auth.isFromPaypal", null);

    if (_isEmpty(data, 'primaryMember', ' ') || _isEmpty(this.props.account, 'preferences', ' ')) {
      return (
        <div className="ma-loading">
          <Loader/>
        </div>
      )
    }

    if (_get(this.props.account, 'status', '') === ACCOUNT_CONTACT_PREF_GET_FAILURE) {
      return (
        <div className="flex m-4">
          <i className="material-icons text-red text-5xl">&#xE001;</i>
          <div className="flex flex-col ml-4 font-bold justify-center">
            <div className='text-red'>{this.localizedStringBundle.PAGE_NOT_ABLE_TO_LOAD_LINE1}</div>
            <div className="mt-1">
              <p>{this.localizedStringBundle.PAGE_NOT_ABLE_TO_LOAD_LINE2}</p>
              <p>{this.localizedStringBundle.PAGE_NOT_ABLE_TO_LOAD_PHONE1}</p>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="flex flex-wrap" id="alert-preferences">
        <div className="w-full pt-8 px-8 bg-white">
          <ContactPrefs/>
          {showTransactionPref && !isFromPaypal ? <TransactionPrefs propAlertPref={this.props.propAlertPref}/> : null}
          {isMobileLogin && <AdditionalPrefs propRNPref={this.props.propRNPref}/>}
        </div>

      </div>
    )
  }
}

AlertPreferences.propTypes = {
  dispatch: PropTypes.func.isRequired,
  key: PropTypes.object,
  auth: authUserType,
  account: PropTypes.object,
  propAlertPref: PropTypes.object,
  propRNPref: PropTypes.object
};

function mapStateToProps(state) {
  const {auth, address, transactions, account} = state;
  return {
    auth, address, account,
    propAlertPref: transactions.alertPreferences,
  }
}

export default connect(mapStateToProps)(AlertPreferences);



// WEBPACK FOOTER //
// ./src/containers/monitoring/AlertPreferences.js